export const validateEmail =(email)=>{
    // Email regex pattern
    const emailPattern = /^[^&?/]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        
    // Check if the email matches the pattern
    return !emailPattern.test(email);
      
}